// extracted by mini-css-extract-plugin
export default {"appNotification":"DiscountReaderStyles_appNotification__4YVFR"};